(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-pill-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const splideByRoot = new Map();

    function destroyRoot(root) {
      const inst = splideByRoot.get(root);
      if (!inst) return;
      inst.destroy();
      splideByRoot.delete(root);
    }

    function initRoot(root) {
      if (typeof Splide === 'undefined') return;

      const splideEl = root.querySelector('.collection-pill-nav__splide');
      if (!splideEl) return;

      destroyRoot(root);

      const parsedStart = parseInt(root.dataset.splideStart || '0', 10);
      const splideStart = Number.isFinite(parsedStart) && parsedStart >= 0 ? parsedStart : 0;

      const inst = new Splide(splideEl, {
        type: 'slide',
        drag: 'free',
        snap: true,
        autoWidth: true,
        gap: '0.75rem',
        pagination: false,
        arrows: true,
        focus: 0,
        omitEnd: true,
        perMove: 3,
        start: splideStart,
        speed: 400,
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        breakpoints: {
          749: {
            arrows: false,
            perMove: 2,
            padding: { left: '1.5rem', right: '1.5rem' },
            gap: '0.625rem',
          },
        },
      });

      inst.mount();
      splideByRoot.set(root, inst);
    }

    function whenSplideReady(callback) {
      const now =
        typeof performance !== 'undefined' && typeof performance.now === 'function'
          ? performance.now.bind(performance)
          : Date.now;
      const deadline = now() + 12000;
      const run = () => {
        if (typeof Splide !== 'undefined') {
          callback();
          return;
        }
        if (now() > deadline) {
          return;
        }
        requestAnimationFrame(run);
      };
      run();
    }

    function initAllRoots() {
      for (const root of document.querySelectorAll('.collection-pill-nav__root[data-section-id]')) {
        initRoot(root);
      }
    }

    function scheduleInit() {
      const tryBoot = () => {
        if (!document.querySelector('.collection-pill-nav__root[data-section-id]')) {
          return;
        }

        whenSplideReady(() => {
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initAllRoots, { once: true });
          } else {
            initAllRoots();
          }
        });
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', tryBoot, { once: true });
      } else {
        tryBoot();
      }
    }

    scheduleInit();

    if (Shopify.designMode) {
      const registryKey = '__soapaCollectionPillNavDesignMode';
      if (window[registryKey]) return;
      window[registryKey] = true;

      document.addEventListener('shopify:section:load', function (e) {
        const sectionId = String(e.detail.sectionId);
        const root = document.querySelector(
          '#shopify-section-' + sectionId + ' .collection-pill-nav__root[data-section-id]'
        );
        if (!root) return;
        whenSplideReady(() => initRoot(root));
      });

      document.addEventListener('shopify:section:unload', function (e) {
        const sectionId = String(e.detail.sectionId);
        const root = document.querySelector(
          '#shopify-section-' + sectionId + ' .collection-pill-nav__root[data-section-id]'
        );
        if (root) destroyRoot(root);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-filters"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('scrollable', () => ({
      isScrollable: false,
      showLeftArrow: false,
      showRightArrow: false,
      observer: null,

      init() {
        this.$nextTick(() => {
          this.checkScrollability();
          this.setupResizeObserver();
        });
      },

      setupResizeObserver() {
        const container = this.$refs.scrollContainer;
        if (!container) return;

        this.observer = new ResizeObserver(() => {
          this.checkScrollability();
        });

        this.observer.observe(container);
      },

      checkScrollability() {
        const container = this.$refs.scrollContainer;
        if (!container) return;

        this.isScrollable = container.scrollWidth > container.clientWidth;
        if (this.isScrollable) {
          this.updateArrows();
        }
      },

      updateArrows() {
        const container = this.$refs.scrollContainer;
        if (!container) return;

        this.showLeftArrow = container.scrollLeft > 0;
        this.showRightArrow = container.scrollLeft < container.scrollWidth - container.clientWidth - 1;
      },

      scroll(direction) {
        const container = this.$refs.scrollContainer;
        if (!container) return;

        const scrollAmount = 300;
        container.scrollBy({
          left: direction === 'left' ? -scrollAmount : scrollAmount,
          behavior: 'smooth',
        });
      },

      destroy() {
        if (this.observer) {
          this.observer.disconnect();
        }
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.resizeTimeout = null;
      this.onResizeHandler = () => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
          this.setHeaderHeight();
        }, 100);
      };
      window.addEventListener('resize', this.onResizeHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      clearTimeout(this.resizeTimeout);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('header-is-sticky');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('header-is-sticky');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.body.classList.remove('header-is-sticky');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tabbed-collection')) {
    customElements.define(
      'tabbed-collection',
      class TabbedCollection extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.viewAllLinks = this.querySelectorAll('[data-view-all]');
          this.prevButton = this.querySelector('button[name="previous"]');
          this.nextButton = this.querySelector('button[name="next"]');
          this.onScroll = this.updateArrows.bind(this);

          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.select(tab));
            tab.addEventListener('keydown', (event) => this.onTabKeydown(event, index));
          });
          [this.prevButton, this.nextButton].forEach((button) => {
            button?.addEventListener('click', () => this.step(Number(button.dataset.step)));
          });
          this.querySelectorAll('[role="tabpanel"] .slider').forEach((slider) => {
            slider.addEventListener('scroll', this.onScroll, { passive: true });
          });

          this.resizeObserver = new ResizeObserver(this.onScroll);
          this.resizeObserver.observe(this);

          // Theme editor: show the panel of the selected block.
          this.onBlockSelect = (event) => {
            const tab = this.tabs.find((t) => t.contains(event.target) || t === event.target);
            if (tab) this.select(tab);
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        get activeSlider() {
          return this.querySelector('[role="tabpanel"]:not([hidden]) .slider');
        }

        select(tab, focus = false) {
          this.tabs.forEach((t) => {
            const selected = t === tab;
            t.setAttribute('aria-selected', String(selected));
            t.tabIndex = selected ? 0 : -1;
            const panel = document.getElementById(t.getAttribute('aria-controls'));
            if (panel) panel.hidden = !selected;
          });

          this.viewAllLinks.forEach((link) => {
            link.href = tab.dataset.url;
            link.setAttribute('aria-label', tab.dataset.viewAllLabel);
          });

          tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          if (focus) tab.focus();

          const slider = this.activeSlider;
          if (slider) slider.scrollLeft = 0;
          this.updateArrows();
        }

        onTabKeydown(event, index) {
          const keys = { ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: this.tabs.length - 1 };
          if (!(event.key in keys)) return;
          event.preventDefault();
          const next = this.tabs[(keys[event.key] + this.tabs.length) % this.tabs.length];
          this.select(next, true);
        }

        slideOffset(slider) {
          const items = Array.from(slider.children).filter((item) => item.clientWidth > 0);
          if (items.length < 2) return slider.clientWidth;
          return items[1].offsetLeft - items[0].offsetLeft;
        }

        step(direction) {
          const slider = this.activeSlider;
          if (!slider) return;
          slider.scrollTo({ left: slider.scrollLeft + direction * this.slideOffset(slider), behavior: 'smooth' });
        }

        updateArrows() {
          if (!this.prevButton || !this.nextButton) return;
          const slider = this.activeSlider;
          const overflow = slider && slider.scrollWidth - slider.clientWidth > 1;
          this.prevButton.disabled = !overflow || slider.scrollLeft <= 1;
          this.nextButton.disabled = !overflow || slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topbar"] && !Shopify.designMode) return;
  try {
    
  let topbarSplide;
  let topbarTimer = null;

  // Rotate messages with a plain timer instead of Splide's autoplay, which
  // runs a requestAnimationFrame loop on every frame to track its interval.
  const topbarMobile = window.matchMedia('(max-width: 768px)');
  const topbarReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const syncTopbarAutoplay = () => {
    window.clearInterval(topbarTimer);
    topbarTimer = null;
    if (!topbarSplide || topbarSplide.length < 2) return;
    if (!topbarMobile.matches || topbarReducedMotion.matches || document.hidden) return;
    topbarTimer = window.setInterval(() => topbarSplide.go('>'), 3000);
  };
  topbarMobile.addEventListener('change', syncTopbarAutoplay);
  topbarReducedMotion.addEventListener('change', syncTopbarAutoplay);
  document.addEventListener('visibilitychange', syncTopbarAutoplay);
  const calculateTopbarHeight = () => {
    const topbarHeight = document.getElementById('topbar').offsetHeight;
    document.documentElement.style.setProperty('--topbar-height', `${topbarHeight}px`);
  };

  const initializeTopbar = () => {
    calculateTopbarHeight();
    if (topbarSplide) topbarSplide.destroy();
    topbarSplide = new Splide('#topbar');
    topbarSplide.on('resize', function () {
      topbarSplide.go(0);
      calculateTopbarHeight();
    });
    topbarSplide.mount();
    // Hold the timer while the user swipes, then restart the countdown.
    topbarSplide.on('drag', () => window.clearInterval(topbarTimer));
    topbarSplide.on('dragged', syncTopbarAutoplay);
    syncTopbarAutoplay();
  };

  document.addEventListener('DOMContentLoaded', initializeTopbar);
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initializeTopbar);
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.querySelector?.('#topbar')) return;
      window.clearInterval(topbarTimer);
      topbarTimer = null;
    });
  }

  } catch(e) { console.error(e); }
})();
})();
